import { ToastContainer, ToastContainerProps } from "react-toastify";
import { Box } from "@mui/material";

export default function StyledToastContainer(props: ToastContainerProps) {
  return (
    <Box
      sx={{
        "--toastify-icon-color-success": "#137f7b",
        "--toastify-color-progress-success": "#137f7b",
        "--toastify-toast-width": "450px",
        ".Toastify__toast": {
          textAlign: "center",
          justifyContent: "center",
        },
      }}
    >
      <ToastContainer
        {...props}
      />
    </Box>
  );
}
